<template>
    <div :class="setClass && setClass.length ? setClass : 'form-group'">
        <button class="active_duplicate duplicate_img" @click="setValue">
            <img src="./icon/dublicate.png" />
        </button>
        <label>Duplicate</label>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Duplicate",
    /* eslint-enable */
    data: () => {
        return {};
    },
    props: ["setClass"],
    methods: {
        setValue(e) {
            this.$emit("set-value", "");
            console.log(e);
        }
    }
};
</script>

<style></style>
